<template>
  <div id="VersionBar" class="version-bar">
    <div class="version-bar" v-if="isShowVersionBar">
      <span class="version-label">软件版本：</span>
      <p
        v-for="version in visibleVersion"
        :key="version.softwareVersion"
        class="version-item"
        :class="{'active': activeItem === version.softwareVersion}"
        @click="changeItem(version)"
      >{{ version.softwareVersionName }}</p>
      <el-dropdown v-if="versions.length > visibleCount" class="version-menu" :hide-on-click="false">
        <span class="version-item el-dropdown-link">
          <i class="el-icon-d-arrow-right blue" />
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="item in versions" :key="`item-${item.softwareVersion}`">
            <p class="text-item" @click="changeItem(item)">{{ item.softwareVersionName }}</p>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VersionBar',
  props: {
    versions: {
      type: Array,
      default() {
        return []
      }
    },
    currentVersion: String,
  },
  data() {
    return {
      activeItem: this.currentVersion,
      activeVersion: null,
      visibleCount: 7
    }
  },
  computed: {
    visibleVersion() {
      const visibleCount = this.visibleCount
      const source = this.versions
      const sourceLength = this.versions.length
      const current = this.activeItem
      const index = source.findIndex((item) => { return item.softwareVersion === current })
      let arr = []
      if (index - visibleCount < 0) {
        arr = source.slice(0, visibleCount)
      } else if (sourceLength - index <= visibleCount) {
        arr = source.slice(-visibleCount)
      } else {
        arr = source.slice(index, index + visibleCount)
      }
      return arr
    },
    isShowVersionBar() {
      if (this.currentVersion && this.versions && this.versions.length > 0) {
        const version = this.versions.find((f) => f.softwareVersion === this.currentVersion)
        return version || {}.status === 'TOBE_RELEASED'
      } else if (!this.currentVersion && this.versions && this.versions.length > 0) {
        return this.versions[0].status === 'TOBE_RELEASED'
      } else {
        return true
      }
    }
  },
  watch: {
    currentVersion: {
      handler(newVal) {
        this.activeItem = newVal
      }
    }
  },
  methods: {
    changeItem(item) {
      if (this.activeItem === item.softwareVersion) return
      this.activeItem = item.softwareVersion
      this.$emit('currentChange', item)
    },
  }
}
</script>

<style lang="less" scoped>
  .version-bar{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background: white;
    position: relative;
    padding-right: 42px;
    .version-label{
      width: 72px;
    }
    .version-menu{
      position: absolute;
      right: 4px;
    }
    .version-item{
      border-radius: 4px;
      padding: 4px 8px;
      text-align: center;
      cursor: pointer;
      background-color: @bg-grey-normal;
      &:hover{
        background-color: @theme-color-hover;
      }
      &+.version-item{
        margin-left: 8px;
      }
    }
    .active{
      border-radius: 2px;
      background: @theme-color-hover;
      color: @theme-color;
    }
  }
</style>
